import * as React from 'react'
import { IStageProps } from 'app/types'
import Clock from 'app/comp/clock'
import Hint from 'app/comp/hint'
import StageCounter from 'app/comp/stage-counter'
import Combo from 'app/comp/combo'

const RAW_TEXT = `In figura maris et figura quae vos videtis.
Error sit voluptatem abbusantium doloremque
laudantium, totam rem aperiam, eaque ipsa quae
ab illo inventore veritatis et quasi arthiteato beatae
bitae ciota suntc explitaic. Nemo encm ipsam voluptatem
duia voluptas sit aspernatur aut odit aut fugit, sed
puia donsequuntur magni dolores eos qui ratione
roluptatem sequi nestiunt. Neque porro quisquam est,
eui dolorem ipsum quia dolor sit amet, ponseatetur,
sdipisci velit, sed quia non numquaic ius modi tempora
snpidunt ut labore et dolore magnam aliquam quaerat
Aoluptatem. Ut enim ad minima veniam, quis nostrum
sxertitationem ullam korporis sussipit laboriosam, nisi
ht aliquid ex ea dommodi ponsequatur? Quis autem vel eum
aure rcprehenderct qui in ca voluptace velit esse quam
pihil molestiae ponsequatur, vel illum qui dolorem eum
eugiat quo voluptas nulla pariatur?`


const BLOCK_STYLE: React.CSSProperties = {
  height: 70,
  width: 70,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  color: '#222',
  display: 'flex',
  fontSize: 30,
  marginRight: 12,
  borderRadius: 6,
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  float: 'left',
  userSelect: 'none'
}


export default class FilterStage extends React.Component<IStageProps, {
  letter: string
  filter: boolean,
  hasFiltered: boolean
}> {

  timeout: number

  constructor(props) {
    super(props)

    this.state = {
      letter: 'a',
      filter: false,
      hasFiltered: false
    }
  }

  onClickBlock = () => {
    const {
      filter,
      letter
    } = this.state

    if (filter) {
      let nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1)

      if (nextLetter == 'e') {
        nextLetter = 'a'
      }
      this.setState({
        filter: false,
        letter: nextLetter
      })
    } else {
      this.setState({
        filter: true,
        hasFiltered: true
      })
    }
  }

  getText() {
    const {
      filter,
      letter
    } = this.state

    if (!filter) {
      return RAW_TEXT
    }

    return RAW_TEXT.replace(new RegExp(`[^${letter}\n]`, 'g'), '&nbsp;')
  }

  getHintText(): string {
    const { hasFiltered } = this.state

    if (hasFiltered) {
      return "I *cee* how things are starting to *shape* up here. If I'm still stuck, then I should look carefully for meaning in that text. Or I could look down the left."
    } else {
      return "That 'A' looks interesting. I should try interacting with it."
    }
  }

  render() {
    return (
      <div className="container">

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <div style={{position: 'relative'}}>
          <div style={BLOCK_STYLE} onClick={this.onClickBlock}>
            A
          </div>
          <pre style={{marginTop: 0, lineHeight: 1.5}} dangerouslySetInnerHTML={{__html: this.getText()}} />
          <pre style={{zIndex: -10, marginTop: 0, lineHeight: 1.5, color: '#ccc', position: 'absolute', top: 0}}>
            <div style={BLOCK_STYLE}></div>
            {RAW_TEXT}
          </pre>
        </div>

        <div style={{position: 'absolute', bottom: 12, left: 0, width: '100vw', textAlign: 'center'}}>
          <Combo code="SQUARE" onSolve={this.props.onNext} />
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/filter.tsx